import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote1: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="close-quote-1, blockquote">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49631 7C5.11863 7 4 8.11829 4 9.5C4 10.8817 5.11863 12 6.49631 12C7.874 12 8.99263 10.8817 8.99263 9.5C8.99263 8.11829 7.874 7 6.49631 7ZM2 9.5C2 7.01571 4.01208 5 6.49631 5C8.9714 5 10.9778 7.00088 10.9925 9.47256C11.2154 13.8468 9.01182 16.5235 5.553 18.8318L4.72122 19.3869L3.61101 17.7233L4.44279 17.1682C5.86999 16.2157 7.40005 15.1909 8.24373 13.6476C7.7066 13.8745 7.11615 14 6.49631 14C4.01208 14 2 11.9843 2 9.5ZM17.4847 7C16.107 7 14.9884 8.11829 14.9884 9.5C14.9884 10.8817 16.107 12 17.4847 12C18.8624 12 19.981 10.8817 19.981 9.5C19.981 8.11829 18.8624 7 17.4847 7ZM12.9884 9.5C12.9884 7.01571 15.0005 5 17.4847 5C19.9598 5 21.9662 7.00088 21.981 9.47256C22.2038 13.8468 20.0002 16.5235 16.5414 18.8318L15.7096 19.3869L14.5994 17.7233L15.4312 17.1682C16.8584 16.2157 18.3885 15.1909 19.2321 13.6476C18.695 13.8745 18.1046 14 17.4847 14C15.0005 14 12.9884 11.9843 12.9884 9.5Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconCloseQuote1;
